import {
  CustomerEntry,
  VehicleEntry,
  VehicleReminderMessageInfoTypeEnum
} from '../../sdk'
import { describeCustomer } from '../describeCustomer/describeCustomer'
import { describeVehicle } from '../describeVehicle/describeVehicle'

export function defaultReminderMessage(
  customer: CustomerEntry | undefined,
  vehicle: VehicleEntry | undefined,
  reminder: VehicleReminderMessageInfoTypeEnum
) {
  const reminderDisplayMap = {
    [VehicleReminderMessageInfoTypeEnum.Inspection]: 'inspection',
    [VehicleReminderMessageInfoTypeEnum.OilService]: 'oil service'
  }

  return (
    'Hi' +
    (customer ? ' ' + describeCustomer(customer) : '') +
    ',\n\nYour vehicle' +
    (vehicle?.info ? ' ' + describeVehicle(vehicle?.info) + ' ' : ' ') +
    'is due for an ' +
    reminderDisplayMap[reminder] +
    '.'
  )
}
